import * as React from "react";
import "./block-badge.css";

import { cn } from "@/lib/utils";

export type BlockBadgeProps = React.HTMLAttributes<HTMLDivElement>;

function BlockBadge({ className, ...props }: BlockBadgeProps) {
  return <div className={cn("tedi-block-badge", className)} {...props} />;
}

export { BlockBadge };
